<template>
  <div
    class="search-input">
    <input
      ref="inputField"
      :value="value"
      v-on:input="onInput"
      type="text"/>
    <font-awesome-icon
      class="icon"
      :icon="icon"/>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faSearch} from '@fortawesome/pro-regular-svg-icons';
export default {
  name: 'SearchInput',
  components: {
    FontAwesomeIcon
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    focus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      icon: faSearch
    };
  },
  mounted () {
    if (this.focus) {
      this.$refs.inputField.focus();
    }
  },
  methods: {
    onInput (event) {
      this.$emit('input', event.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables";

  .search-input {
    position: relative;
  }

  input {
    border: 1px solid $black-trans6;
    border-radius: 2em;
    padding: $sp-margin-smaller;
    padding-left: 2rem;
  }

  .icon {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/SearchInput.vue